import { createContext, useContext } from 'react';
import { CancelFlowConfig } from '../types';

export const ConfigContext = createContext<CancelFlowConfig | null>(null);

export function useConfigContext() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfigContext must be used within ConfigContext.Provider');
  }
  return context;
}
